"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Agreement = void 0;
const GetAgreementDetails_1 = require("./GetAgreementDetails");
const GetAgreementList_1 = require("./GetAgreementList");
const PostAgreementAdd_1 = require("./PostAgreementAdd");
const PostAgreementEdit_1 = require("./PostAgreementEdit");
const PostAgreementDelete_1 = require("./PostAgreementDelete");
__exportStar(require("./GetAgreementDetails"), exports);
__exportStar(require("./GetAgreementList"), exports);
__exportStar(require("./PostAgreementAdd"), exports);
__exportStar(require("./PostAgreementEdit"), exports);
__exportStar(require("./PostAgreementDelete"), exports);
exports.Agreement = {
    GetAgreementDetails: GetAgreementDetails_1.GetAgreementDetails,
    GetAgreementList: GetAgreementList_1.GetAgreementList,
    PostAgreementAdd: PostAgreementAdd_1.PostAgreementAdd,
    PostAgreementEdit: PostAgreementEdit_1.PostAgreementEdit,
    PostAgreementDelete: PostAgreementDelete_1.PostAgreementDelete
};
//# sourceMappingURL=index.js.map